import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M247 0L1673.28571 0 1673.28571 501.942857 1470.31429 501.942857 1470.31429 202.971429 1072.6 202.971429 1072.6 1717.02857 1374.31429 1717.02857 1374.31429 1920 543.228571 1920 543.228571 1717.02857 844.942857 1717.02857 844.942857 202.971429 449.971429 202.971429 449.971429 501.942857 247 501.942857z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextLine, _Component);

  var _super = _createSuper(IconTextLine);

  function IconTextLine() {
    _classCallCheck(this, IconTextLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconText",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextLine.displayName = "IconTextLine";
  return IconTextLine;
}(Component);

IconTextLine.glyphName = 'text';
IconTextLine.variant = 'Line';
IconTextLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextLine;
export { IconTextLine };